import React from 'react';
import { BrandMark } from './BrandMark';
export function Footer() {
  return <footer className="bg-brand-950 px-4 pb-32 pt-10 text-center sm:pb-28" data-id="element-169" data-mp="3gezcj1s77n03">
      <div className="flex justify-center" data-id="element-170" data-mp="3ghc0bvkn0rl2">
        <BrandMark tone="dark" data-id="element-171" data-mp="32onjn0nshk7w" />
      </div>
      <p className="mt-4 text-sm text-brand-200" data-id="element-172" data-mp="32lrk57wamnhc">© 2026 · Dr. Michael Carter</p>
      <p className="text-sm text-brand-300" data-id="element-173" data-mp="36pzb7bq84fiq">All rights reserved.</p>
    </footer>;
}